/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { BUY_ASSET_IN_FIAT } from "../pages/ProductDetail/graphql/buy-asset-in-fiat.mutation";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import axios from "axios";
import { VApplication } from "../application";
import { themeConfig } from "../providers/theme";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { UNLOCK_ASSET_BY_USER } from "../pages/ProductDetail/graphql/unlock-asset-by-user.mutation";
import { EventBusModule } from '@vlinder-web/event-bus-module-react';
import { SIGN_VOUCHER_MESSAGE } from "./test-data/fiat-purchase-voucher-message";
import {LOCK_ASSET_AFTER_PURCHASE_SUCCESS} from "../pages/ProductDetail/graphql/lock-asset-after-purchase-success.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";

import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export const FIAT_TX_SUCCESS = 'fiat-service.tx-success';
export const FIAT_RAZORPAY_TX_ERROR = 'fiat-service.tx-razorpay-rror';
export const FIAT_TX_ERROR = 'fiat-service.tx-error';
export const FIAT_TX_MODAL_DISMISSED = 'fiat-service.modal-dismissed';

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();


interface IProps {
    key:any ,
    baseURL:any,
    scriptURL:any,
    storeId:any,
 }
const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
export class FiatDetailService {
    private static instance: FiatDetailService;
    private vapp: VApplication;
    private eventbus: any;
    private key;
    private baseURL;
    private scriptURL;
    private storeId;

    private constructor(props: IProps |any = {}) {
        this.vapp = VApplication.getInstance();
        this.eventbus = EventBusModule?.getInstance()?.getEventBus();
        this.key = props?.key;
        this.baseURL = props?.baseURL;
        this.scriptURL =props?.scriptURL;
        this.storeId = props?.storeId

    }
    public static getInstance(props:IProps | any = {}): FiatDetailService {
        if (!FiatDetailService.instance) {
            FiatDetailService.instance = new FiatDetailService(props);
        }
        console.log("FIATSER",FiatDetailService.instance)
        return FiatDetailService.instance;
    }

    async createOrderId(asset: any, signature: any, user_profile?: any) {
        // const _found = _.find(DETAIL_DATA, { idx: assetId });
        log.blue(SERVICE_NAME, `inside create orderId`, this?.baseURL);
        const _found = asset;
        if (_found) {
            const _fiat = _.find(_found.price, { type: "fiat" });
            if (_fiat) {
                //call backend for the asset Id and create a new Order !!
                const orderId = await this.getOrderId({
                    idx: _found?.idx,
                    tokenGroup: _found?.tokenGroup,
                    successUrl: _found?.successUrl,
                    cancelUrl:_found?.cancelUrl,
                    signature,
                });

                console.log(`orderId inside create orderId`, orderId);
                let _description = _found?.subtitle?.replace(/<[^>]+>/g, '')?.substring(0, 100);

                if(orderId?.session?.provider === "razorpay"){
                    const options = this.getOptions({
                        key_id: `${this.key}`,
                        provider: orderId?.session?.provider,
                        amount: Math.round(orderId?.session?.order?.amount * 100),
                        currency: _fiat.currency,
                        name: _found?.title,
                        description: _description,
                        image: _found?.img,
                        order_id: orderId?.session?.order?.id, //populate from backend response
                        user_name: user_profile?.name,
                        user_email: user_profile?.email,
                        user_contact: user_profile?.contact,
                        user_address: user_profile?.address,
                        theme: themeConfig?.colors?.primary,
                        retry: {
                            enabled:false
                        },
                        backend_endpoint: `${this.baseURL}`, // populate verify backend end point
                    });
                    return options;
                }
                if(orderId?.session?.provider === "stripe"){
                    let _stripeOptions = orderId?.session;
                    return _stripeOptions;
                }
                
            }
        }
    }

    async getStripeCheckout(data:any, signature:any){
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            return true;
            // if (client) {
            //     const res = await client.mutate({
            //         mutation: UNLOCK_ASSET_BY_USER,
            //         variables: {
            //             input:{
            //                 tokenId: data?.asset?.idx,
            //                 tokenGroupId: data?.asset.tokenGroup
            //             },
            //             auth:{
            //                 signature: signature?.result,
            //                 expected_address: signature?.params[1],
            //                 message: SIGN_VOUCHER_MESSAGE,
            //             }
            //         },
            //     });
            //     if (res?.data) {
            //         return res?.data;
            //     }
            // }
        } catch (err) {
            getErrorMessage(err);
        }
    }

    async unlockAssetByOwner(data:any, signature:any){
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UNLOCK_ASSET_BY_USER,
                    variables: {
                        input:{
                            tokenId: data?.asset?.idx,
                            tokenGroupId: data?.asset.tokenGroup
                        },
                        auth:{
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }

    async lockAssetAfterPurchase(data:any, signature:any){
        console.log(`asset lock data`, data)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LOCK_ASSET_AFTER_PURCHASE_SUCCESS,
                    variables: {
                           input:{
                            tokenId: data?.idx,
                            tokenGroup: data?.tokenGroup,
                            txnType:'fiat'
                           },
                           auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }

    async displayRazorpay(orderId: any) {
        const res = await this.loadScript(
           this.scriptURL
        );

        if (!res) {
            throw Error("Are you online?");
        }
        //@ts-ignore
        const paymentObject = new window.Razorpay(orderId);
        paymentObject?.on("payment.failed", (response: any) => {
            this.eventbus?.emit(FIAT_RAZORPAY_TX_ERROR, null, {
                message: response.error?.reason,
            });

            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
        });
        paymentObject.open();
    }

    private async getOrderId(order: any) {
        log.info(`inside initiate claim service`, order?.idx);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: BUY_ASSET_IN_FIAT,
                    variables: {
                        input: {
                            tokenId: order?.idx,
                            tokenGroup: order?.tokenGroup,
                            storeId: this.storeId,
                            successUrl: order?.successUrl,
                            cancelUrl:order?.cancelUrl
                        },
                        auth: {
                            signature: order?.signature?.result,
                            expected_address: order?.signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                if (res?.data) {
                    return res?.data?.buyAssetInFiatNew;
                }
            }
        } catch (err) {
            getErrorMessage(err);
        }
        // try {
        //     const res = await axios.post(
        //         `${DEFAULT_APP_CONFIG.servers.rest.paymentGatewayServer.baseURL}/orders`,
        //         order
        //     );
        //     return res?.data;
        // } catch (err) {
        //     console.log("error in order id ", err);
        // }
    }

    private loadScript(src: any) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    private getOptions({
        key_id,
        amount,
        provider,
        currency,
        name,
        description,
        image,
        order_id,
        user_name,
        user_email,
        user_contact,
        user_address,
        theme,
        retry,
        backend_endpoint,
    }: any) {
        let options: any = {
            key: key_id,
            provider: provider,
            amount: amount?.toString(),
            currency: currency,
            order_id: order_id,
            retry:retry,
            "modal": {
                "ondismiss": () => {
                    this.eventbus?.emit(FIAT_TX_MODAL_DISMISSED, null, {});
                }
            }
        };
        if (name) {
            options.name = name;
        }
        if (description) {
            options.description = description;
        }
        if (image) {
            options.image = { logo: image };
        }
        options.handler = async (response: any) => {
            const data: any = {
                orderCreationId: order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                razorpaySignature: response.razorpay_signature,
            };
            try {
                const result = await axios.post(backend_endpoint, data);
                if (result?.data) {
                    this.eventbus?.emit(FIAT_TX_SUCCESS, null, result?.data);
                }
            }
            catch (error: any) {
                console.log("error in fiat transaction verificaiton", error?.message);
                this.eventbus?.emit(FIAT_TX_ERROR, null, {
                    message: error?.message
                });
            }

        };
        if (user_name || user_email || user_contact) {
            if (user_name) {
                options.prefill = {
                    name: user_name,
                };
            }
            if (user_email) {
                options.prefill = {
                    ...(options.prefill || {}),
                    email: user_email,
                };
            }
            if (user_contact) {
                options.prefill = {
                    ...(options.prefill || {}),
                    contact: user_contact,
                };
            }
        }
        if (user_address) {
            options.notes = {
                address: user_address,
            };
        }
        if (theme) {
            options.theme = {
                color: theme,
            };
        }
        return options;
    }
}
